module.exports = __webpack_public_path__ + "static/media/Project-Build.f9427b80.svg";